import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import arEG from "date-fns/locale/ar-EG";
import { convertToArabicNumbers } from '../utils/numberUtils';

  const DateFilter = ({
    selectedDate,
    startDate,
    endDate,
    setSelectedDate,
    setStartDate,
    setEndDate,
    onDateFilterChange,
    onDateRangeChange,
    clearAllFilters,
    trackerSettings,
    hasActiveFilters,
    isDisabled = false

    // applyFilters
}) => {
    const date_filters = [
      { label: trackerSettings?.last_7_days, value: "last_7_days" },
      { label: trackerSettings?.last_month, value: "last_month" },
      { label: trackerSettings?.last_3_months, value: "last_3_months" },
      { label: trackerSettings?.last_6_months, value: "last_6_months" },
    ];
  
    const handleDateChange = (value) => {

      if (selectedDate === value) {
        setSelectedDate(null); 
        onDateFilterChange(null);
      }
      else{
        setSelectedDate(value);
        onDateFilterChange(value); 
        setStartDate(null);
        setEndDate(null)
      }
    };

    const handleDateRangeChange = (dates) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      onDateRangeChange({ start, end });
      setSelectedDate(null)
    };

    const locale = localStorage.getItem('language');
    
    registerLocale("ar", arEG);
  
    const CustomInput = React.forwardRef(({ value, onClick, locale }, ref) => (
      <input
        ref={ref}
        onClick={onClick}
        value={locale === "ar" ? convertToArabicNumbers(value) : value}
        placeholder={trackerSettings?.date_placeholder}
        className={`date-picker-range w-100 ps-2 date-filter ${isDisabled ? "disabled-input" : ""}`}
        readOnly
      />
    ));
    
  
    return (
      
        <div className="row justify-content-between align-items-center date-filter">
          <div className="col-12 col-lg-7">
            <div className="row g-3">
              {date_filters.map((filter) => (
                <div key={filter.value} className="col-6 col-lg-auto">
                  <button
                    className={`sectoral-filter date-filter w-100 text-start text-lg-center ${selectedDate === filter.value ? "active-filter" : ""}`}
                    onClick={() => handleDateChange(filter.value)}
                    disabled={isDisabled}
                    style={{
                      cursor: isDisabled ? "default" : "pointer",
                      opacity: isDisabled ? 0.6 : 1,
                      backgroundColor: isDisabled ? "#f5f5f5" : "",
                    }}x
                  >
                    <p className="mb-0 text-left">{filter.label}</p>
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 col-lg-5 mt-3 mt-lg-0 justify-content-lg-end justify-content-between d-lg-flex">
            <div className="row align-items-center g-3">
              <div className="col-6 ">
                <DatePicker
                placeholderText={trackerSettings?.date_placeholder}
                onChange={handleDateRangeChange}
                startDate={startDate}
                endDate={endDate}
                selected={startDate}
                disabled={isDisabled}
                selectsRange
                className={`date-picker-range w-100 ps-2 date-filter ${isDisabled ? "disabled-date-picker" : ""}`}
                locale={locale === "en" ? "" : "ar"} 
                renderDayContents={locale === 'en' ? undefined : (day) => convertToArabicNumbers(day)} 
                customInput={<CustomInput locale={locale} value={startDate ? startDate.toLocaleDateString() : ""} disabled={isDisabled} />}
                />
              {/* <button onClick={applyFilters} className="btn btn-primary">
                  Apply Filters
              </button> */}
              </div>
              {hasActiveFilters && (
                <div className="col-6 text-end">
                  <p
                    className="font-bold mb-0"
                    style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                    onClick={clearAllFilters}
                  >
                    {trackerSettings?.clear_all}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      
    );
  };
  
  export default DateFilter;
